/*
 * Copyright (c) Nexign, JSC, 2020-2023.
 */

/**
 * Constants for Wizard Product Offerings
 *
 * @author Aleksandr Perkhunov
 * @author Yakov Gushchin
 * @author Ilya Baranchikov
 * @version 1.27.0
 * @since 1.10.0
 */

export enum EWizardProductOfferingsSteps {
    StepSelectSubscribers = 'SubscriberConfigurerStep',
    StepSelectMegaPowers = 'MegaPowersConfigurerStep',
    StepSelectDate = 'ActivationDateConfigurerStep',
    StepConfirmation = 'ActivateOrderFinalStep',
}

export enum EProductSubscribersTableField {
    ACCOUNT = 'account',
    ACTION_CONFLICTS = 'actionConflicts',
    COST = 'cost',
    LABELS = 'labels',
    MSISDN = 'msisdn',
    NAME = 'name',
    RATE_PLAN = 'ratePlan',
}

export enum EProductSubscribersActivationListField {
    ACCOUNT_NUMBER = 'accountNumber',
    COST = 'cost',
    DELETE = 'delete',
    INFO = 'info',
    MSISDN = 'msisdn',
    STATUS = 'status',
}

/*
 * -------------------------------------------
 *           ACTIONS
 * -------------------------------------------
 */

export const PRODUCT_OFFERING_HANDLE_NEXT = '@@b2b_portal_ui/wizardProductOfferings/PRODUCT_OFFERING_HANDLE_NEXT';
export const PRODUCT_OFFERING_SET_PARAMS = '@@b2b_portal_ui/wizardProductOfferings/PRODUCT_OFFERING_SET_PARAMS';
export const PRODUCT_OFFERING_SET_MEGAPOWER = '@@b2b_portal_ui/wizardProductOfferings/PRODUCT_OFFERING_SET_MEGAPOWER';
export const PRODUCT_OFFERING_START_VALIDATE = '@@b2b_portal_ui/wizardProductOfferings/PRODUCT_OFFERING_START_VALIDATE';
export const PRODUCT_OFFERING_SET_STEP_VALID = '@@b2b_portal_ui/wizardProductOfferings/PRODUCT_OFFERING_SET_STEP_VALID';
export const PRODUCT_OFFERING_CLEAR = '@@b2b_portal_ui/wizardProductOfferings/PRODUCT_OFFERING_CLEAR';
export const PRODUCT_OFFERING_SAVE_STORAGE = '@@b2b_portal_ui/wizardProductOfferings/PRODUCT_OFFERING_SAVE_STORAGE';
export const PRODUCT_SUBSCRIBERS_LIST_INIT_START =
    '@@b2b_portal_ui/wizardProductOfferings/PRODUCT_SUBSCRIBERS_LIST_INIT_START';

export const PRODUCT_OFFERING_GET_SUBSCRIBERS_CHECK_LIST_ACTION =
    '@@b2b_portal_ui/wizardProductOfferings/PRODUCT_OFFERING_GET_SUBSCRIBERS_CHECK_LIST_ACTION';
export const PRODUCT_OFFERING_GET_SUBSCRIBERS_CHECK_LIST_SUCCESS =
    '@@b2b_portal_ui/wizardProductOfferings/PRODUCT_OFFERING_GET_SUBSCRIBERS_CHECK_LIST_SUCCESS';
export const PRODUCT_OFFERING_GET_SUBSCRIBERS_CHECK_LIST_FAILURE =
    '@@b2b_portal_ui/wizardProductOfferings/PRODUCT_OFFERING_GET_SUBSCRIBERS_CHECK_LIST_FAILURE';

export const PRODUCT_OFFERING_CREATE_INQUIRY_START =
    '@@b2b_portal_ui/wizardProductOfferings/PRODUCT_OFFERING_CREATE_INQUIRY_START';
export const PRODUCT_OFFERING_CREATE_INQUIRY_SUCCESS =
    '@@b2b_portal_ui/wizardProductOfferings/PRODUCT_OFFERING_CREATE_INQUIRY_SUCCESS';
export const PRODUCT_OFFERING_CREATE_INQUIRY_FAILURE =
    '@@b2b_portal_ui/wizardProductOfferings/PRODUCT_OFFERING_CREATE_INQUIRY_FAILURE';
